import { render, staticRenderFns } from "./InitiateHome.vue?vue&type=template&id=7c126ee8&"
import script from "./InitiateHome.vue?vue&type=script&lang=js&"
export * from "./InitiateHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports